import { Link as RouterLink } from 'react-router';
import {
  Avatar,
  Box,
  Divider,
  ListItemIcon,
  MenuItem,
  Stack,
  Typography,
} from '@mui/material';

import { SwitchClient } from '@features/shared/client/switch-client';

import { useAccount } from '@entities/shared/account';
import { useMyClients, useSelectedClientStore } from '@entities/shared/client';

import { logout } from '@shared/lib/auth';
import { ChevronDownIcon, Home01Icon, LogOut01Icon, Users02Icon } from '@shared/ui/icons';
import { Popover } from '@shared/ui/popover';
import { SelectableOptionItem } from '@shared/ui/selectable-option-item';

import { TriggerButtonStyled } from './user-menu.styled';

export const UserMenu = () => {
  const me = useAccount();
  const clients = useMyClients();
  const selectedClient = useSelectedClientStore();

  const currentClient = clients.data?.find(
    (client) => client.clientId === selectedClient.clientId,
  );

  return (
    <Popover
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      trigger={({ onClick }) => (
        <TriggerButtonStyled onClick={onClick} disableRipple>
          <Avatar sx={{ width: 32, height: 32 }} />
          <Stack alignItems="flex-start" minWidth={0}>
            <Typography variant="body2" fontWeight={600} noWrap height={20}>
              {me.data?.username}
            </Typography>
            <Typography variant="caption" color="grey.500" noWrap>
              {currentClient?.name}
            </Typography>
          </Stack>
          <ChevronDownIcon sx={{ color: 'grey.500', fontSize: 18 }} />
        </TriggerButtonStyled>
      )}
    >
      <Box width={320} pt={2} color="text.primary">
        <Stack alignItems="center" gap={1} px={2} pb={2}>
          <Avatar sx={{ width: 56, height: 56 }} />
          <Stack alignItems="center">
            <Typography variant="subtitle1" fontWeight={600}>
              {me.data?.username}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {me.data?.email}
            </Typography>
          </Stack>
        </Stack>

        {(clients.data?.length ?? 0) > 0 && (
          <SwitchClient
            render={({ selectedId, onSelect }) => (
              <Stack gap={1} px={1} pb={2}>
                <Typography variant="caption" color="text.secondary">
                  Компанія
                </Typography>
                {clients.data?.map((client) => (
                  <SelectableOptionItem
                    key={client.clientId}
                    selected={selectedId === client.clientId}
                    onClick={() => onSelect(client.clientId)}
                  >
                    <Typography variant="body2" fontWeight={600} noWrap>
                      {client.name}
                    </Typography>
                  </SelectableOptionItem>
                ))}
              </Stack>
            )}
          />
        )}

        <Divider />

        <Box p={1}>
          <MenuItem component={RouterLink} to="/settings/profile">
            <ListItemIcon>
              <Users02Icon fontSize="small" />
            </ListItemIcon>
            Профіль
          </MenuItem>
          <MenuItem component={RouterLink} to="/settings/company">
            <ListItemIcon>
              <Home01Icon fontSize="small" />
            </ListItemIcon>
            Компанія
          </MenuItem>
          <MenuItem onClick={logout}>
            <ListItemIcon>
              <LogOut01Icon fontSize="small" />
            </ListItemIcon>
            Вийти
          </MenuItem>
        </Box>
      </Box>
    </Popover>
  );
};
